import { FlexBox, Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { StatsTheme } from '../../types'
import { ReaderStatCards } from './ReaderStatCards'
import { ReaderSummaryHeader } from './ReaderSummaryHeader'
import { ReaderSummaryText } from './ReaderSummaryText'
import { getStatsYear } from '../../lib/utils'
import { useStats } from '../../lib/ctx/stats'
import { useStatCards } from './useStatCards'

interface Props {
  theme: StatsTheme
  summary: string
}

export const ReaderSummaryShareCard = ({ theme, summary }: Props) => {
  const { colors } = useTheme()
  const stats = useStats((s) => s.stats)
  const year = getStatsYear(stats?.created_at || '')
  const yearColor = theme.key === 'pink' ? theme.primary : colors.uiWhite
  const statCards = useStatCards()

  return (
    <>
      <span
        className={css`
          display: block;
          width: 100%;
          height: 50%;
          background-color: ${theme.summaryBg};
          position: absolute;
          bottom: 0;
          left: 0;
          z-index: 1;
        `}
      >
        <span
          className={css`
            display: block;
            width: 100%;
            height: 100px;
            background: linear-gradient(rgba(0, 0, 0, 0), ${theme.summaryBg});
            position: absolute;
            top: -100px;
            left: 0;
          `}
        />
      </span>
      <FlexBox
        className={css`
          position: relative;
          padding: 16px 20px 20px;
          width: 392px;
          z-index: 2;
        `}
        flexDirection="column"
      >
        <FlexBox
          className={css`
            gap: 2px;
          `}
          flexDirection="column"
        >
          <Text
            type="script"
            custom={{
              fontSize: '36px',
              lineHeight: '32px',
              letterSpacing: '-1px',
            }}
            color={yearColor}
          >
            My {year}
          </Text>
          <Text
            type="header"
            custom={{
              fontSize: '46px',
              lineHeight: '42px',
              letterSpacing: '-0.5px',
            }}
            color={colors.uiWhite}
          >
            Reading
            <br />
            <span>stats on Fable</span>
          </Text>
        </FlexBox>
        <FlexBox
          className={css`
            margin-top: 6px;
            margin-bottom: 8px;
            width: 100%;
            padding: 12px;
            background-color: ${theme.summaryBg};
            border-radius: 16px;
          `}
          flexDirection="column"
        >
          <ReaderSummaryHeader />
          <ReaderSummaryText color={theme.summaryText} text={summary} />
        </FlexBox>
        <ReaderStatCards statCards={statCards} />
      </FlexBox>
    </>
  )
}
